/** Normalize file-upload API payloads ({ result: { url } } or legacy shapes). */
export function resolveUploadUrl(data) {
  const result = data?.result;
  if (!result) return null;
  if (typeof result === "string") return result;
  return result.url || result.secure_url || null;
}

export function getApiErrorMessage(err, fallback = "Request failed") {
  const data = err?.response?.data;
  if (!data) return err?.message || fallback;
  return data.message || data.mesasge || fallback;
}
